/**
 * The help centre: short articles on how to use the apps, written by admins in the admin console
 * (or through the admin MCP server) and read in the athlete app, the coach app or both.
 */

/** The app whose help centre lists an article. An article names one or both. */
export enum HelpAudience {
  ATHLETE = "athlete",
  COACH = "coach",
}

/** Whether readers see an article. A draft is only in the admin console. */
export enum HelpArticleStatus {
  DRAFT = "draft",
  PUBLISHED = "published",
}

/**
 * The picture a help category shows on its card. A fixed list, so every app can draw each one and
 * an admin picks rather than types.
 */
export enum HelpCategoryIcon {
  START = "start",
  CALENDAR = "calendar",
  TRAINING = "training",
  NUTRITION = "nutrition",
  PROGRESS = "progress",
  PAYMENTS = "payments",
  CLIENTS = "clients",
  ACCOUNT = "account",
  PRIVACY = "privacy",
  QUESTIONS = "questions",
}

/** What somebody writing in through a contact page wants, so the message lands with the right person. */
export enum ContactTopic {
  SUPPORT = "support",
  BILLING = "billing",
  SALES = "sales",
  PRIVACY = "privacy",
  OTHER = "other",
}

/** The app a contact message was sent from. */
export enum ContactApp {
  ATHLETE = "athlete",
  COACH = "coach",
}
